import React, { useState } from 'react'
import { App, } from 'antd'
import { useJiekuanZTXGMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
function LoanWithdraw(props) {
    const {message} = App.useApp()
    const [ztxg] = useJiekuanZTXGMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    
    const handleZTXG = () => {
        // 如果正在提交中，直接返回
        if (isSubmitting) {
            return;
        }
        // 设置提交状态
        setIsSubmitting(true);        
        ztxg({
            jk_id:props.jk_id,
            jk_state: '1',
        }).then((res) => {
            if(res.data.Status === 'success') {
                message.success('借款单取消提交成功！')
            }else{
                message.error('借款单取消提交失败！'+res.data.Message)
            }
            // 3秒后恢复可点击状态
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        }).catch((err) => {
            // 出错时也要恢复状态
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        })
    }    
    return (
        <Icon 
            type='withdraw' 
            onClick={() => handleZTXG()} 
            disabled={isSubmitting}
            style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        />
    )
}

export default LoanWithdraw